import { deserialize } from 'cerialize'
import { AstSigned, PartnerBg, StatusBg, UserBg } from 'Pages/ibro'
import moment from 'moment'
import { DATE_FORMAT_SHORT } from 'Constants/Global'

export interface BgLimitRequestMeta {
	bg_product_exist?: boolean
}

export class BgLimitRequest {
	@deserialize public id?: number
	@deserialize public name?: string
	@deserialize public inn?: string
	@deserialize public amount?: string
	@deserialize public approved_amount?: string
	@deserialize public status?: StatusBg
	@deserialize public created_at?: string
	@deserialize public external_id?: string | null
	@deserialize public partner?: PartnerBg
	@deserialize public created_by_user?: UserBg
	@deserialize public limit_remain?: string | null
	@deserialize public limit_to?: string | null
	@deserialize public limit_updated_at?: string | null
	@deserialize public ast_signed?: AstSigned | null

	public get date(): string | undefined {
		return moment(this?.created_at).format(DATE_FORMAT_SHORT)
	}

	public get limit_updated_at_date(): string {
		return this?.limit_updated_at ? moment(this?.limit_updated_at).format(DATE_FORMAT_SHORT) : ''
	}

	public get limit_to_date(): string {
		return this?.limit_to ? moment(this?.limit_to).format(DATE_FORMAT_SHORT) : ''
	}
}
